import React from "react";

const PriceChopperPageFooter = () => {
  return (
    <div className="p-4 float-left w-full box-border">
      <p className="text-sm leading-5">
        For special deals and deep discounts on restaurant supplies, check out
        our current price chopper sales! If you’re looking for discounted
        restaurant equipment, furniture, and kitchen supplies, check back
        regularly to find restaurant supplies for sale. Cheap restaurant
        equipment doesn’t have to be low value! You’ll find that our discount
        restaurant equipment all comes from trusted brands that offer a
        dependable product for an affordable price.
      </p>
      <p className="text-sm leading-5">
        WebstaurantStore price choppers are limited time price reductions on
        popular restaurant supplies. Each week we add new items to our
        collection of discount restaurant equipment to help you save. You can
        find even deeper discounts on our{" "}
        <a href="/outlet.html" target="_blank" className="underline">
          <strong>Scratch and Dent Outlet</strong>
          <span className="sr-only">, opens in a new tab</span>
        </a>{" "}
        page.
      </p>
      <p className="text-sm leading-5">
        You never know what’s going to turn up on our price chopper page! From
        discount catering supplies to restaurant dinnerware, you can find deals
        on a variety of commercial restaurant supplies. Stay up to date on our{" "}
        <a
          href="/blog/2150/monthly-coupon-code-update.html"
          target="_blank"
          className="underline"
        >
          <strong>monthly coupon code</strong>
          <span className="sr-only">, opens in a new tab</span>
        </a>{" "}
        and find even more ways to save!
      </p>
    </div>
  );
};

export default PriceChopperPageFooter;
